import { List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { newUUID } from '@vy/utils';

export const RenewContractNewTermsStepDetails: React.FC = () => {
  const details = getRenewContractNewTermsStepDetails();

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      <Stack
        direction="column"
        sx={{
          width: "594px",
          alignItems: "flex-start",
          gap: "8px"
        }}>
        <Typography variant="subtitle1" sx={{
          fontWeight: 600
        }}>
          Start a new contract with no prefilled terms
        </Typography>

        <List dense disablePadding sx={{ listStyleType: 'disc', pl: 2 }}>
          {details.map((detail) => (
            <ListItem key={newUUID()} disablePadding sx={{ py: 0.5, display: 'list-item' }}>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{
                    color: "text.primary"
                  }}>
                    {detail}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Stack>
    </Stack>
  );
};

function getRenewContractNewTermsStepDetails() {
  return ['Use a blank plan', 'Add products and pricing', 'Set a start date and contract duration'];
}
